var map = {
	"./account--avatar.svg": "./src/assets/shortcuts-icons/avatars/account--avatar.svg",
	"./developers--avatar.svg": "./src/assets/shortcuts-icons/avatars/developers--avatar.svg",
	"./directory--avatar.svg": "./src/assets/shortcuts-icons/avatars/directory--avatar.svg",
	"./documents--avatar.svg": "./src/assets/shortcuts-icons/avatars/documents--avatar.svg",
	"./folios--avatar.svg": "./src/assets/shortcuts-icons/avatars/folios--avatar.svg",
	"./metrics--avatar.svg": "./src/assets/shortcuts-icons/avatars/metrics--avatar.svg",
	"./notifications--avatar.svg": "./src/assets/shortcuts-icons/avatars/notifications--avatar.svg",
	"./pos--avatar.svg": "./src/assets/shortcuts-icons/avatars/pos--avatar.svg",
	"./purchases--avatar.svg": "./src/assets/shortcuts-icons/avatars/purchases--avatar.svg",
	"./reports--avatar.svg": "./src/assets/shortcuts-icons/avatars/reports--avatar.svg",
	"./sii--avatar.svg": "./src/assets/shortcuts-icons/avatars/sii--avatar.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/shortcuts-icons/avatars sync recursive ^\\.\\/.*\\-\\-avatar\\.svg$";